import './../scss/main.scss';
import { App } from './App';
import { DomReady, getConfigBase } from '@jollywise/jollygoodgame';
import { Load } from './game/scenes/Load';
import { SceneOnboardingPlugin } from './game/components/SceneOnboardingPlugin';

const gameConfig = getConfigBase({
  components: {
    loader: { data: { displayScene: Load, cachebuster: __VERSION__ } },
    onboarding: { component: SceneOnboardingPlugin },
  },
});

DomReady(() => {
  const config = { ...gameConfig };
  new App({ config, paths: { base: './', assets: 'assets/' } });
});
